module.exports = __webpack_public_path__ + "static/media/carrorama-banner-main-cut.d2458d5c.png";